import { render, staticRenderFns } from "./PurimPayments.vue?vue&type=template&id=3be1596f&"
import script from "./PurimPayments.vue?vue&type=script&lang=js&"
export * from "./PurimPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports